<template>
  <div :style="{ backgroundImage: 'url(' + bgImage + ')' }" id="div-bg">
    <v-card class="mx-auto" width="700px" style="border-radius: 13px" elevation="20">
      <v-row no-gutters>
        <v-col>
          <v-img class="fs-logotipo-login" :src="logo"/>
          <v-form class="ma-5 px-3">
            <span style="font-size: 14px; font-weight: 300; letter-spacing: .5px">Digite seu E-mail e Senha:</span>
            <v-text-field
              class="mt-8"
              type="text"
              v-model="email"
              label="E-mail"
              placeholder=" "
              style="font-size: 13px"
              autofocus
              spellcheck="false"
              outlined
              dense
            />
            <v-text-field
              class="mt-n2"
              type="password"
              v-model="senha"
              @keyup.enter="formSubmit"
              spellcheck="false"
              style="font-size: 13px"
              label="Senha"
              placeholder=" "
              outlined
              dense
            />
            <v-btn block @click="formSubmit()" :disabled="loading" color="primary">
              Entrar
            </v-btn>
            <div class="mt-5" style="text-align: center; width: 100%">
              <router-link to="forgot">
                <u>Esqueceu sua senha?</u>
              </router-link>
            </div>
            <div class="fs-device-desc">
              {{ this.getDevice.browser_nome }} | Versão: {{ this.getDevice.browser_versao }} | S.O.: {{
              this.getDevice.os_nome }} {{ this.getDevice.os_versao }}
              <br>
              ID: {{ this.getHash }}
            </div>
          </v-form>
        </v-col>
        <v-col>
          <div id="div-card-image">
            <v-img class="fs-card-image" :src="signInImage"/>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Vue from 'vue'

export default {
  metaInfo: {
    title: 'Login'
  },
  data () {
    return {
      codigo: '',
      device: {},
      email: '',
      senha: '',
      userId: '',
      bgImage: require('@/assets/images/bg2.jpg'),
      logo: require('@/assets/images/logo.png'),
      signInImage: require('@/assets/images/photo-long-5.jpg')
    }
  },
  computed: {
    ...mapGetters('authData', ['loggedInUser', 'loading', 'error']),
    ...mapGetters('device', ['getDevice', 'getHash']),
    validation () {
      return this.userId.length > 4 && this.userId.length < 13
    }
  },

  async mounted () {
    this.device = await this.identificarDevice()
  },
  methods: {
    ...mapActions('authData', ['login']),
    ...mapActions('device', ['identificarDevice', 'findDevice', 'addDevice', 'editDevice']),
    ...mapMutations('device', ['DEVICE']),
    ...mapMutations('global', ['setSnackbar']),

    // Método do Botão Entrar (type = submit)
    async formSubmit () {
      const deviceFingerPrint = Object.assign({}, this.getDevice)
      deviceFingerPrint.fingerprint = Vue.$cookies.get('__farsoft_fingerprint')

      deviceFingerPrint.chave_liberacao = Math.floor((Math.random() * 999999) + 900000)

      // Chama a mutation para atualizar a chave fingerPrint (só pode ser feita depois de ter lido)
      this.DEVICE(deviceFingerPrint)

      const login = await this.login({ email: this.email, senha: this.senha, aplicacao: 'crm' })
      if (login) {
        // Verificar se o fingerprint do dispositivo está cadastrado e liberado
        // Tenta localizar no BD o device com o fingerprint
        const dispositivo = await this.findDevice(deviceFingerPrint.fingerprint)
        if (dispositivo && dispositivo.error) {
          // Inclui o DEVICE(dispositivo) no banco de dados
          const addResult = await this.addDevice(deviceFingerPrint)
          // Atualiza o device do state para pegar o ID
          this.DEVICE(addResult)
          this.$router.push('/app/sessions/device')
        } else {
          // Atualiza o device do state com o dispositivo encontradopara pegar o ID
          this.DEVICE(dispositivo)
          if (dispositivo.liberado === 'N') {
            this.$router.push('/app/sessions/device')
          } else {
            window.localStorage.setItem('fingerprint', Vue.$cookies.get('__farsoft_fingerprint'))
            // Redireciona para o MENU
            this.$router.push('/app/dashboards/dashboard.v1')
          }
        }
      }
    }
  },
  watch: {
    error (val) {
      if (val != null) {
        this.setSnackbar({ msg: 'Login incorreto, verifique!', color: 'error' })
      }
    }
  }
}
</script>

<style scoped>
  #div-bg {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    height: 100vh;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
  #div-card-image {
    width: 350px;
  }
  .fs-card-image {
    border-top-right-radius: 13px;
    border-bottom-right-radius: 13px;
    width: 100%;
  }
  .fs-logotipo-login {
    width: 100px !important;
    margin-top: 30px;
    margin-left: 122px;
  }
  .fs-device-desc {
    text-align:center;
    margin-top: 80px;
    margin-bottom: -10px;
    font-size: 10px;
    padding-left: 5px;
    padding-right: 5px;
    font-weight: 300;
    letter-spacing: .4px;
    color: black;
  }
</style>
